import { Button } from "@shared/src/components/ui/button";
import { Card } from "@shared/src/components/ui/card";
import { P2P_PAGE, P2P_PAGE_EXTERNAL } from "@shared/src/config/page-links";
import { useHostStore } from "@shared/src/stores/useHostStore";
import { useQuickTradeFlowStore } from "@shared/src/stores/useQuickTradeFlowStore";

export function QuickTradeExpiredView() {
  const flowStore = useQuickTradeFlowStore();
  const router = useHostStore(state => state.router);
  const onAdjust = () => flowStore.goToForm();
  // const onGoToP2P = () => router.push(P2P_PAGE);
  return (
    <div className="flex flex-col items-center justify-center w-full min-h-[60vh]">
      <Card variant="secondary" className="w-full max-w-lg p-16">
        <div className="text-center space-y-3 mb-6">
          <h5 className="font-medium text-text-primary text-lg">No merchants available to fulfil your order</h5>
          <p className="text-text-secondary">Please try P2P trading or adjust options.</p>
        </div>
        <div className="flex gap-3 justify-center">
          <Button variant="outline" size="cta" onClick={onAdjust} className="px-6">
            Adjust options
          </Button>
          {/* <Button onClick={onGoToP2P} variant="primary" size="cta" className="px-6">
            Try P2P trading
          </Button> */}
        </div>
      </Card>
    </div>
  );
}
